/* eslint-disable react/no-danger */
import { dangerousGettext, gettext } from '@eventbrite/i18n';
import React from 'react';
import './rightSizePricingHero.scss';

const ContentWrapper = (props: React.PropsWithChildren<{}>) => (
    <div className="rsp-hero__bg-container">{props.children}</div>
);

export const RightSizePricingHero: React.FC = ({ children }) => (
    <section className="rsp-hero">
        <ContentWrapper>
            <div className="rsp-hero__content-container">
                <header className="rsp-hero__header-boost">
                    <h1>
                        <strong>{gettext('JOIN OUR COMMUNITY.')}</strong>
                        <br />
                        <span className="semi-bold">
                            {gettext('GROW YOURS.')}
                        </span>
                    </h1>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: dangerousGettext(
                                "Reach <strong>90 million</strong> eventgoers on the <strong>world's largest</strong> event marketplace.",
                            ).toString(),
                        }}
                    ></p>
                </header>
                {children && (
                    <div className="rsp-hero__overlap-block">{children}</div>
                )}
            </div>
        </ContentWrapper>
    </section>
);
